module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/attachment-2-ab3b5c01450285004cd2f1532ac48f9c.svg";